module.exports = __webpack_public_path__ + "static/img/home_remark_02.c6aee25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home_remark_02.png
// module id = NOpE
// module chunks = 1